import { useEffect, useState } from 'react';

type Variant = 'winner' | 'loser';

const BG_MAP = {
  winner: {
    mobile: () => import('@/assets/trivia-bg--winner-mob.jpg'),
    desktop: () => import('@/assets/trivia-bg--winner-desk.jpg'),
  },
  loser: {
    mobile: () => import('@/assets/trivia-bg--loser-mob.jpg'),
    desktop: () => import('@/assets/trivia-bg--loser-desk.jpg'),
  },
} as const;

export function useTriviaBg(isMobile: boolean, variant: Variant) {
  const [bg, setBg] = useState<string>('');

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const importer = isMobile
        ? BG_MAP[variant].mobile
        : BG_MAP[variant].desktop;

      const mod = await importer();

      if (!cancelled) {
        setBg(mod.default);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [isMobile, variant]);

  return bg;
}
